import { useMapEvents } from "react-leaflet";
import type L from "leaflet";

/** Listens for map clicks and returns coordinates. Ignores clicks on markers so drag still works. */
const MapClickHandler: React.FC<{
  onClick: (lat: number, lng: number) => void;
}> = ({ onClick }) => {
  useMapEvents({
    click(e: L.LeafletMouseEvent) {
      const target = e.originalEvent?.target as HTMLElement | undefined;
      if (target?.closest?.(".leaflet-marker-icon")) return;
      const { lat, lng } = e.latlng;
      onClick(lat, lng);
    },
  });

  return null;
};

export default MapClickHandler;

//EX OF USAGE

// import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
// import { useState } from "react";
// import SearchControl from "./SearchControl";
// import MapClickHandler from "./MapClickHandler";

// const MapComponent = () => {
//   const [clickedPos, setClickedPos] = useState<[number, number] | null>(null);

//   return (
//     <MapContainer
//       center={[51.505, -0.09]}
//       zoom={13}
//       style={{ height: "100vh", width: "100%" }}
//     >
//       <TileLayer
//         url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//         attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//       />

//       <SearchControl />

//       <MapClickHandler onClick={(lat, lng) => setClickedPos([lat, lng])} />

//       {clickedPos && (
//         <Marker position={clickedPos}>
//           <Popup>
//             📍 You clicked here: <br />
//             <b>Lat:</b> {clickedPos[0].toFixed(5)} <br />
//             <b>Lng:</b> {clickedPos[1].toFixed(5)}
//           </Popup>
//         </Marker>
//       )}
//     </MapContainer>
//   );
// };

// export default MapComponent;
